/**
 * These theme properties should be considered legacy. Make efforts to avoid new usage as well as refactor out existing
 * usage.
 */

import type { ComponentsProps } from '@material-ui/core/styles/props'

import { props } from './props'

export const adminLightPlaceholder = { placeholder: 'rgba(0, 0, 0, 1)' }

export const adminDarkPlaceholder = { placeholder: 'rgba(255, 255, 255, 0.37)' }

export const adminThemeStatus = {
  status: {
    disabled: {
      opacity: 0.55,
    },
  },
}

export const BASE_Z_INDEX = 1100000

export const adminThemeZIndex = {
  zIndex: {
    mobileStepper: BASE_Z_INDEX + 1000,
    appBar: BASE_Z_INDEX + 1100,
    drawer: BASE_Z_INDEX + 1200,
    modal: BASE_Z_INDEX + 1300,
    snackbar: BASE_Z_INDEX + 1400,
    tooltip: BASE_Z_INDEX + 9100,
  },
}

/** The defaults for MuiInputBase and MuiInputLabel can be removed once the BasicForm & 'shared' inputs have either:
 * 1. been refactored to use secondary color.
 * 2. been replaced with new common components.
 *
 * props as imported from './props' are part updated design system.
 */
export const adminThemeDefaultProps: { props: ComponentsProps } = {
  props: {
    ...props,
    // Legacy below
    MuiCard: {
      elevation: 0,
    },
    MuiTooltip: {
      title: '',
      placement: 'right',
    },
    MuiPaper: {
      elevation: 0,
    },
    MuiAppBar: {
      position: 'static',
    },
    MuiInputBase: {
      color: 'secondary',
    },
    MuiInputLabel: {
      color: 'secondary',
    },
  },
}
